// Herinneringen in de ouder-webapp (0021): het blok "Herinneringen" in de afspraak-editor, het
// formulier (wanneer, tekst, pictogram, voor wie, voorlezen, geluid) met een voorbeeld zoals de
// tablet het toont, en de chips op het afspraakblad. Sleutels in `a.reminders.*` (app.nl.ts).
export const appRemindersNl = {
    section: 'Herinneringen',
    sectionHint: 'Een extra seintje op de tablet: het scherm roept je kind bij naam, met een groot plaatje. Met een afvinklijstje van wat er mee moet.',
    allDayHint: 'Herinneringen werken bij afspraken met een tijd.',
    add: 'Herinnering',
    addTitle: 'Nieuwe herinnering',
    editTitle: 'Herinnering wijzigen',
    edit: 'Wijzigen',
    remove: 'Weghalen',
    removed: 'Herinnering weggehaald',
    /** Knop onder het formulier (niet "Klaar": het gaat mee bij "Afspraak opslaan"). */
    confirmAdd: 'Herinnering toevoegen',
    confirmSave: 'Herinnering bijwerken',
    /** Het kruisje rechtsboven in het formulier. */
    closeForm: 'Formulier sluiten zonder deze herinnering',
    max: 'Hooguit 5 herinneringen per afspraak.',
    when: 'Wanneer',
    customWhen: 'Eigen tijd',
    customLabel: 'Minuten vooraf',
    customHint: '1 tot 1440 minuten (een dag).',
    offsetInvalid: 'Kies 1 tot 1440 minuten.',
    text: 'Tekst',
    textPlaceholder: 'Klaarmaken voor trainen',
    textRequired: 'Vul een korte tekst in.',
    textTooLong: 'Maximaal 60 tekens.',
    suggestions: 'Voorstellen',
    picto: 'Pictogram',
    forWho: 'Voor wie',
    everyone: 'Iedereen van de afspraak',
    /** "Voor wie" zonder keuze bij een afspraak met kinderen én volwassenen: de kinderen. */
    everyoneKids: 'Alle kinderen',
    whoRequired: 'Kies voor wie deze herinnering is.',
    // Leden uit de afspraak gehaald (de herinnering wordt meteen bijgewerkt).
    prunedChanged: '{names} doet niet meer mee; herinnering "{title}" is aangepast.',
    prunedChangedMany: '{names} doen niet meer mee; herinnering "{title}" is aangepast.',
    prunedRemoved: '{names} doet niet meer mee; herinnering "{title}" is weggehaald.',
    prunedRemovedMany: '{names} doen niet meer mee; herinnering "{title}" is weggehaald.',
    /** Bij een herhaling: bijsnoeien geldt alleen voor "Deze en volgende" en "Alle". */
    prunedThisHint: 'Kies je bij opslaan "Alleen deze keer", dan blijven de herinneringen voor de andere keren gewoon staan.',
    allDayDrop: 'Bij een hele dag roept de tablet niet: deze herinneringen gaan weg als je opslaat.',
    and: 'en',
    speak: 'Voorlezen',
    speakHint: 'De tablet zegt de naam en de tekst hardop.',
    sound: 'Geluid',
    soundHint: 'Een zacht belletje (niet in de stille uren).',
    preview: 'Zo roept de tablet',
    previewOk: 'Oké',
    previewContext: '{title} om {time}',
    previewNoTitle: 'Afspraak',
    /** Duur vooraf, kort. */
    minutes: '{count} min',
    hours: '{count} uur',
    hoursMinutes: '{hours} uur {minutes} min',
    before: '{when} vooraf',
    /** Chip op het afspraakblad en in de lijst. */
    chip: '{when} vooraf · {title}',
    chipLabel: 'Herinnering {when} vooraf: {title}',
    // Per keer overslaan op het afspraakblad (alleen bij een herhaling).
    skipOnce: 'Alleen deze keer niet',
    skipOnceLabel: 'Herinnering "{title}" alleen deze keer niet',
    skipOnceDone: 'Deze keer roept de tablet niet: {title}',
    skippedChip: 'Deze keer niet',
    unskip: 'Toch roepen',
    unskipLabel: 'Herinnering "{title}" deze keer toch roepen',
    unskipDone: 'Deze keer roept de tablet weer: {title}',
    // Slimme voorstellen op basis van de afspraak.
    suggestTraining: 'Klaarmaken voor trainen',
    suggestSwim: 'Zwemtas pakken',
    suggestBag: 'Tas klaarzetten',
    suggestShoes: 'Schoenen en jas aan',
    suggestGeneric: 'Klaarmaken voor {title}',
    suggestGenericEmpty: 'Klaarmaken',
    // 0055: tijd per taak, omroepen op het bord (taak-editor).
    taskTime: 'Tijd',
    taskTimeHint: 'Mag leeg blijven.',
    taskAnnounce: 'Omroepen op het bord',
    taskAnnounceHint: "Op die tijd klinkt een belletje en zegt de tablet wie wat moet doen. Stil in de stille uren en 's nachts.",
};
//# sourceMappingURL=remindersApp.nl.js.map